<script>
	import {createEventDispatcher} from 'svelte';
	export let btnClass;
	export let initPage;
	export let room;
	export let ws;
	export let SocketClient;
	export let socketAddr;
	export let gameAlert = function(msg) {
		alert(msg);
	};

	const dispatch = createEventDispatcher();
	let roomId = '';
	let waitTime = 8;
	let auctionTime = 10;
	let waitTimeGroup = [3,5,8,10];
	let auctionTimeGroup = [3,5,8,10];
	let disabled = true;
	
	//방ID가 입력되어야만 생성 버튼을 누룰 수 있음 
	let roomStateChange = function() {
		disabled = false;
	}
	
	$: verifiedID = roomId.trim().length && roomId.trim().length <= 200 && !roomId.includes('%');
	
	//룸 객체 갱신
	const makeRoomInfo = function(e) {
		if (e && e.type === 'keypress' && e.which !== 13) {
			return;
		}
		if (!verifiedID) {
			gameAlert(`방 ID 앞, 뒤로 공백이 없이 200자 이내로 <b>%</b> 기호를 제외하고 입력하여 주십시오.`);
			return;
		}
		if (![3,5,8,10].includes(waitTime)) {
			gameAlert(`경매 대기 시간은 <b>3</b>, <b>5</b>, <b>8</b>, <b>10</b> 초 중에서 선택하여야 합니다.`);
			return;
		}
		if (![3,5,8,10].includes(auctionTime)) {
			gameAlert(`경매 시간은 <b>3</b>, <b>5</b>, <b>8</b>, <b>10</b> 초 중에서 선택하여야 합니다.`);
			return;
		}
		roomId = roomId.trim();
		room.id = roomId.trim();
		room.players = 1;
		room.waitTime = waitTime;
		room.auctionTime = auctionTime;
		
		ws = new SocketClient(socketAddr);
		ws.connect();
		ws.socket.create(roomId, '', waitTime, auctionTime);
		ws.socket.addCallback('error', (type, msg) => {
			if (type.startsWith('ROOM_CREATE')) {
				cancel();
			}
		});
		room.gameStatus = 'create';
	}
	
	/**
	 * 생성 취소
	 */
	const cancel = function() {
		if (ws instanceof SocketClient) {
			ws.disconnect();
		}
		room.gameStatus = 'wait';
	}
</script>

<!-- S : PAGE[2] - 방 생성 -->
<div class="game-modal-wrap" class:on={btnClass.create} data-modal="create">
	{#if room.gameStatus === 'wait'}
	<div class="modal create">
		<dl class="game-list">
			<div class="group">
				<dt><label for="room-id">방 ID</label></dt>
				<dd><input type="text" id="room-id" placeholder="함께하는 참가자에게 공유하세요" bind:value="{roomId}" on:keypress={makeRoomInfo}></dd>
			</div>
			<div class="group">
				<dt><label for="wating-time">경매 대기 시간</label></dt>
				<dd>
					<select class="select-box" id="wating-time" bind:value={waitTime}>
						{#each waitTimeGroup as num}
							<option value="{num}">{num}</option>
						{/each}
					</select>
				</dd>
			</div>
			<div class="group">
				<dt><label for="auction-time">경매 시간</label></dt>
				<dd>
					<select class="select-box" id="auction-time" bind:value={auctionTime}>
						{#each auctionTimeGroup as num}
							<option value="{num}">{num}</option>
						{/each}
					</select>
				</dd>
			</div>
		</dl>
		<div class="btn-wrap">
			<button type="button" class="info"><strong>{room.players}/6명</strong></button>
			<div class="group">
				<button type="button" class="btn" on:click={makeRoomInfo}>방 만들기</button>
				<button type="button" class="btn gray-border" on:click={initPage}>취소</button>
			</div>
		</div>
	</div>
	{:else}
	<div class="modal start">
		<div class="txt-box">
			<p class="title">매칭 중...</p>
			<p class="desc">방 ID : <b>{room.id}</b><br><br>매칭 참가자를 기다리는 중 입니다</p>
		</div>
		<div class="btn-wrap">
			<div class="info">대기중... <strong>{room.players}/6명</strong></div>
			<button type="button" class="btn gray-border" on:click={cancel}>취소</button>
		</div>
	</div>
	{/if}
</div>
<!-- E : PAGE[2] - 방 생성 -->

<style lang="scss">
</style>